import { faBadgeCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { CreateUserBadgeForm } from '~/components/forms/UserBadgeForm';
import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { Heading } from '~/components/molecules/Heading';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { useNavigate } from '~/components/utils/Navigation';

export type ICreateUserBadgePageProps = {
  appId: string;
};

export const AppCreateUserBadgePage: React.FC<ICreateUserBadgePageProps> = (
  props,
) => {
  const { appId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const parentUrl = `/apps/${appId}/badges`;

  return (
    <>
      <Helmet>
        <title>{t('AppCreateUserBadgePage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faBadgeCheck} />
          {t('AppUserBadgesPage.title')}
        </Breadcrumbs.Action>
      </AppBreadcrumbs>

      <Heading
        title={t('AppCreateUserBadgePage.title')}
        previousUrl={parentUrl}
      />

      <CreateUserBadgeForm
        appId={appId}
        onSuccess={(createdUserBadge) =>
          navigate(`/apps/${createdUserBadge.userBadge.appId}/badges`)
        }
        cancelUrl={parentUrl}
      />
    </>
  );
};
